import { FileDownload } from "@mui/icons-material";
import { Button, Grid, Typography } from "@mui/material";
import { useAppSelector } from "../../app/store/configureStore";

const CompleteVerification = () => {
  const { user } = useAppSelector((state) => state.account);
  const HomeVistor = user?.credentialTypeId === 4;
  const downloadWorksheet = () => {
    const link = document.createElement("a");
    link.download = `CDAVerificationVisitReflectiveDialogWorksheet.pdf`;
    link.href = "./docs/CDAVerificationVisitReflectiveDialogWorksheet.pdf";
    link.click();
  };

  return (
    <Grid container bgcolor={"myVerify.light"} p={3}>
      <Grid item xs={12} mb={2}>
        <Typography fontWeight={700} fontSize={18}>
          {HomeVistor && "2."} Verification Visit Reflective Dialogue Worksheet
        </Typography>
        <Typography>
          The last step of your verification visit process is the Reflective
          Dialogue. This culminating activity is designed to support your
          ongoing reflection about your professional practices. This dialogue
          will occur during your verification visit with your Professional
          Development Specialist. It is a confidential conversation that will
          not be scored and has no bearing on the award of your credential.
          Please download the Reflective Dialogue form here or found in the back
          of your CDA Competency Standards book, which will be used during your
          visit. Prior to your visit, please complete section one of step one.
          The other sections and steps will be completed during the verification
          visit.
        </Typography>
      </Grid>
      <Grid item xs={12} mb={2}>
        <Button
          variant="outlined"
          color="myVerify"
          sx={{ textTransform: "initial" }}
          onClick={downloadWorksheet}
        >
          <FileDownload />
          Download Reflective Dialogue Worksheet
        </Button>
      </Grid>
    </Grid>
  );
};
export default CompleteVerification;
